module.exports = __webpack_public_path__ + "../assets/img/7388fe6676dc6c91bf8eb254a650372c.svg";